"use strict"

import "./POIProperties.css";
import React from "react";
import classnames from "classnames";

import dispatcher from "./../../dispatcher";
import poiStore from "./../../store/pois";
import editedPOIStore from "./../../store/editedPOI";
import poiModificationStore from "./../../store/poiModifications";
import poiCollaborationStore from "./../../store/poiCollaborations";

import Form from "vwa/components/Form";
import ProgressBar from "vwa/components/ProgressBar";
import Card from "vwa/components/Card";
import Button from "vwa/components/Button";
import Input from "vwa/components/Input";
import ColorPicker from "vwa/components/ColorPicker";
import Toast from "vwa/components/Toast";
import ConfirmDialog from "vwa/components/ConfirmDialog";
import lang from "vwa/lang";
import EEP from "vfu/EEP";

import {getPrivilegeOfPOI} from "./../../utils/poi";
import getPOICollaborations from "./../../api/getPOICollaborations";
import savePOI from "./../../api/savePOI";
import deletePOI from "./../../api/deletePOI";

const DEFAULT_COLOR = "#FFFFFF";

export default class POIProperties extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
		this.eep = new EEP();
		this.setStoreListeners();
	}
	
	initState(){
		this.state = {
			inProgress: false,
			poi: poiStore.get(this.props.poiId),
			modifications: this.getModificationsFromStore(),
			editedPOIId: editedPOIStore.get()
		};
	}
	
	getModificationsFromStore() {
		const modDoc = poiModificationStore.get(this.props.poiId)
		if (!modDoc)
			return {};
		return modDoc.modifications;
	}
	
	setStoreListeners() {
		this.eep.on(poiStore, "update", poi => {
			if (poi._id == this.props.poiId)
				this.setState({poi});
		});
		this.eep.on(poiModificationStore, "insert", modificationDocs => {
			const modificationDoc = modificationDocs.find(md => md.poi == this.props.poiId);
			if (!modificationDoc)
				return;
			this.setState({
				modifications: this.getModificationsFromStore()
			});
		});
		this.eep.on(poiModificationStore, "update", modificationDoc => {
			if (modificationDoc.poi == this.props.poiId)
			this.setState({
				modifications: this.getModificationsFromStore()
			});
		});
		this.eep.on(poiModificationStore, "remove", modificationDocs => {
			const modificationDoc = modificationDocs.find(md => md.poi == this.props.poiId);
			if (!modificationDoc)
				return;
			this.setState({
				modifications: this.getModificationsFromStore()
			});
		});
		this.eep.on(editedPOIStore, "change", editedPOIId => this.setState({editedPOIId}));
	}
	
	componentWillUnmount() {
		this.eep.close();
	}
	
	getValue(field) {
		if (field in this.state.modifications)
			return this.state.modifications[field];
		else return this.state.poi[field];
	}
	
	canEdit() {
		const privilege = getPrivilegeOfPOI(this.props.poiId);
		return privilege >= 2;
	}
	
	canDelete() {
		const privilege = getPrivilegeOfPOI(this.props.poiId);
		return privilege == 4;
	}
	
	hasModifications() {
		return Object.keys(this.state.modifications).length > 0;
	}
	
	getShapeEditingButtonLabel() {
		if (this.state.editedPOIId == this.props.poiId)
			return lang.RESTORE_SHAPE;
		else
			return lang.EDIT_SHAPE;
	}
	
	async save() {
		this.setState({inProgress: true});
		await savePOI(this.props.poiId);
		this.setState({inProgress: false});
	}
	
	handleShapeEditingButton() {
		if (this.state.editedPOIId == this.props.poiId) {
			dispatcher.dispatch("restorePOIShape", this.props.poiId);
			dispatcher.dispatch("editPOI", null);
		}
		else {
			dispatcher.dispatch("editPOI", this.props.poiId);
		}
	}
	
	confirmDeleting() {
		ConfirmDialog.open({
			text: lang.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_POI,
			onConfirm: () => this.deletePOI()
		});
	}
		
	async deletePOI() {
		this.setState({inProgress: true});
		deletePOI(this.props.poiId);
		this.setState({inProgress: false});
	}
	
	getSaveButtonDisabled() {
		return !this.canEdit() || !this.hasModifications();
	}
	
	render(){
		return(
			<div className="POIProperties">
				<header className="Shadowed">
					<Button
						className="Red"
						onClick={()=> this.save() }
						disabled={this.getSaveButtonDisabled()}
					>{lang.SAVE}</Button>
					<Button
						onClick={() => this.handleShapeEditingButton()}
						disabled={!this.canEdit()}
					>{this.getShapeEditingButtonLabel()}</Button>
					<Button
						onClick={() => this.confirmDeleting()}
						disabled={!this.canDelete()}
					>{lang.DELETE}</Button>
				</header>
				<ProgressBar
					indeterminate
					shown={this.state.inProgress}
				/>
				<div className={classnames("Content", {"Hidden": this.state.inProgress})}>
					<Card>
						<Form>
							<label>{lang.NAME}</label>
							<Input
								value={this.getValue("name") || ""}
								onChange={evt => dispatcher.dispatch("modifyPOI", this.props.poiId, {name: evt.target.value})}
								disabled={!this.canEdit()}
							/>
							
							<label>{lang.ADDRESS}</label>
							<Input 
								value={this.getValue("address") || ""}
								onChange={evt => dispatcher.dispatch("modifyPOI", this.props.poiId, {address: evt.target.value})}
								disabled={!this.canEdit()}
							/>
							
							<label>{lang.COLOR}</label>
							<ColorPicker
								color={this.getValue("color") || DEFAULT_COLOR}
								onChange={ color => dispatcher.dispatch("modifyPOI", this.props.poiId, {color}) }
								disabled={!this.canEdit()}
							/>
						</Form>
					</Card>
				</div>
			</div>
		)
	}
	
}

POIProperties.propTypes = {
	poiId: React.PropTypes.string
};

POIProperties.defaultProps = {
	poiId: null
};


// WEBPACK FOOTER //
// ./src/view/POIProperties/POIProperties.jsx